// base react-slick 0.28.2
import Slider from './slider';

export default Slider;
